import { render, staticRenderFns } from "./informationCase.vue?vue&type=template&id=bef22fe0&scoped=true&"
import script from "./informationCase.vue?vue&type=script&lang=js&"
export * from "./informationCase.vue?vue&type=script&lang=js&"
import style0 from "./informationCase.vue?vue&type=style&index=0&id=bef22fe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef22fe0",
  null
  
)

export default component.exports